import Aegis from '@tencent/aegis-web-sdk';
import { getCookie } from 'sutils';

const speedLogBlockList = [
    // 远程演示获取房间信息，房间人数满时会降级使用此接口轮询。
    '/show-api/getroominfo',
];

export default class MeetingRoomReport {
    private static instance: MeetingRoomReport;

    public static getInstance(): MeetingRoomReport {
        if (!MeetingRoomReport.instance) {
            MeetingRoomReport.instance = new MeetingRoomReport();
        }
        return MeetingRoomReport.instance;
    }

    public aegis: Aegis;
    private reportPerformanceNowOnceMap = {};

    private constructor() {
        this.init();
    }

    public reportPerformanceNow(name: string, once = false) {
        if (once) {
            if (this.reportPerformanceNowOnceMap[name]) return;
            this.reportPerformanceNowOnceMap[name] = true;
        }
        this.aegis.reportTime(name, performance.now());
    }

    public reportPerformanceNowNotEditor = (scenceEditorRemote: boolean, name: string, once = false) => {
        if (!scenceEditorRemote) {
            this.reportPerformanceNow(name, once);
        }
    };

    public setDocType = docType => this.aegis.setConfig({ ext2: docType });

    public setRole = role => this.aegis.setConfig({ ext3: role });

    private init() {
        this.initAegis();
    }

    private initAegis() {
        const MEETING_ROOM_AEGIS_ID = 'ZvszvAcZWifBwCAPQO';
        this.aegis = new Aegis({
            id: MEETING_ROOM_AEGIS_ID, // 项目ID
            reportApiSpeed: true, // 接口测速
            reportAssetSpeed: true, // 静态资源测速
            beforeReportSpeed(log: { url: string }) {
                // 屏蔽部分接口测速
                if (log?.url && speedLogBlockList.some(url => log.url.includes(url))) return false;
            },
            hostUrl: 'https://rumt-zh.com/',
        });

        this.aegis.setConfig({
            // 约定 ext1 标识 <渠道>
            ext1: getCookie('open_theme_id'),
            // 约定 ext2 标识 <文档类型>
            ext2: 'unknow',
            // 约定 ext3 标识 <身份>
            ext3: 'unknow',
        });
    }
}
